import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { ReportingService } from '../reporting.service';
import { ReportBatch } from '../models/report-batch.model';
import { ConfirmCancelArchiveReportComponent } from './confirm-cancel-archive.component';
import { DataSource } from '../models/data-source.model';
import * as moment from 'moment';

@AutoUnsubscribe()
@Component({
    selector: 'appArchiveProcess',
    templateUrl: './archive-process.component.html',
    styleUrls: ['./archive-process.component.css']
})

export class ArchiveProcessComponent implements OnDestroy, OnInit {



    // private snapshotToDelete: AutoRunSnapshot;

    private _reportName: string;
    // private _autoRunDate: Date;

    get reportName(): string {
        return this._reportName;
    }

    set reportName(value: string) {
        this._reportName = value;
    }

    archiveTypes = '';

    fromDate: Date;
    // processStatus: string[] = [];

    // get autoRunDate(): Date {
    //     return this._autoRunDate;
    // }

    // set autoRunDate(value: Date) {
    //     this._autoRunDate = value;
    // }

    ReportBatches: ReportBatch[] = [];
    confirmCancelArchiveDialogRef: MatDialogRef<ConfirmCancelArchiveReportComponent>;

    processes: DataSource[] = [];
    selectedProcess: string;
    filteredBatches: ReportBatch[] = [];

    addedBys: DataSource[] = [];
    addedBy: string;

    viewArchiveProcessesFromAllUsers: boolean;
    allowCancelArchiveProcesses: boolean;
    allowDeleteArchivedReports: boolean;

    constructor(
        private reportService: ReportingService,
        private dialogRef: MatDialogRef<ArchiveProcessComponent>,
        private confirmCancelArchiveDialog: MatDialog,
    ) {

    }

    ngOnInit() {


        this.viewArchiveProcessesFromAllUsers = this.reportService.viewArchiveProcessesFromAllUsers;
        this.allowCancelArchiveProcesses = this.reportService.allowCancelArchiveProcesses;
        this.allowDeleteArchivedReports = this.reportService.allowDeleteArchivedReports;

        const today = this.reportService.getDateWithoutTime(); // new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0);

        // this.fromDate = today; // new Date();

        if (this.reportService.SelectedReport != null && this.reportService.SelectedReport != undefined) {
            this.reportName = this.reportService.SelectedReport.Name;
        }
        // if (this.reportService.SelectedReport.StudentDigitalContent != null) {
        //     this.archiveTypes = this.archiveTypes + 'Student Digital Content\n';
        // }

        // if (this.reportService.SelectedReport.StudentPortfolio != null) {
        //     this.archiveTypes = this.archiveTypes + 'Student Portfolio\n';
        // }

        // if (this.reportService.SelectedReport.ArchiveToTCM) {
        //     this.archiveTypes = this.archiveTypes + 'Tyler Content Manager\n';
        // }

        this.reportService.getReportBatches().subscribe(archiveBatches => {
            for (let x = 0; x < archiveBatches.length; x++) {
                this.setAddedOnDate_Display(archiveBatches[x]);
            }



            this.ReportBatches = archiveBatches;
            this.filteredBatches = archiveBatches;
            this.getAddedBys();

            this.fromDate = this.getMinDate();

            let process = new DataSource();
            process = new DataSource();
            process.TextField = 'All';
            this.selectedProcess = 'All';
            this.processes.push(process);

            for (let x = 0; x < archiveBatches.length; x++) {
                if (!this.processes.find(p => p.TextField == archiveBatches[x].ProcessingDescription)) {
                    process = new DataSource();
                    process.TextField = archiveBatches[x].ProcessingDescription;
                    this.processes.push(process);
                }
            }

            // var minDate=new Date(Math.min.apply(null, archiveBatches.));


        });



    }

    // itemExistsInArray() {

    // }

    getAddedBys() {
        const users: string[] = [];

        for (let x = 0; x < this.ReportBatches.length; x++) {

            const tempUsers = users.find(u => u == this.ReportBatches[x].AddedByName);
            if (tempUsers == null || tempUsers == undefined) {
                users.push(this.ReportBatches[x].AddedByName);
            }
        }
        const sortedAddedBys = users.sort((a, b): number => {
            if (a < b) {
                return -1;
            }
            if (a > b) {
                return 1;
            }
            return 0;
        });

        let addby = new DataSource();
        addby.TextField = 'All';
        this.addedBys.push(addby);
        this.addedBy = 'All'; // default

        for (let w = 0; w < sortedAddedBys.length; w++) {
            addby = new DataSource();
            addby.TextField = sortedAddedBys[w];
            this.addedBys.push(addby);
        }

    }

    getMinDate(): Date {
        let myMinDate = new Date();
        for (let x = 0; x < this.ReportBatches.length; x++) {
            if (new Date(this.ReportBatches[x].AddedOn).getTime() < new Date(myMinDate).getTime()) {
                myMinDate = this.ReportBatches[x].AddedOn;
            }
        }
        return myMinDate;
    }



    setAddedOnDate_Display(batch: ReportBatch) {
        batch.AddedOnDate_Display = moment(batch.AddedOn).format('MM/DD/YYYY h:mm:ss a');
    }

    fromDateChanged() {
        this.filteredBatches = this.getFilteredItems();
    }

    processChanged() {
        this.filteredBatches = this.getFilteredItems();
    }

    getFilteredItems(): ReportBatch[] {
        const batches: ReportBatch[] = [];

        for (let x = 0; x < this.ReportBatches.length; x++) {

            if (this.selectedProcess != 'All') {
                // filtering on process
                if (this.ReportBatches[x].ProcessingDescription == this.selectedProcess) {

                    if ( // moment(this.fromDate, ['MM/DD/YYYY']).isValid() &&
                        // moment(this.ReportBatches[x].AddedOn).isAfter(this.fromDate)
                        this.isThisDateEqualToOrAfterThatDate(this.ReportBatches[x].AddedOn, this.fromDate)
                        && (this.addedBy == 'All' || this.ReportBatches[x].AddedByName == this.addedBy)) {
                        batches.push(this.ReportBatches[x]);
                    }

                }
            }
            else {
                // not filtering on process
                if ( // moment(this.fromDate, ['MM/DD/YYYY']).isValid() &&
                    // moment(this.ReportBatches[x].AddedOn).isAfter(this.fromDate)

                    this.isThisDateEqualToOrAfterThatDate(this.ReportBatches[x].AddedOn, this.fromDate)
                    && (this.addedBy == 'All' || this.ReportBatches[x].AddedByName == this.addedBy)) {
                    batches.push(this.ReportBatches[x]);
                }
            }
        }

        return batches;
    }

    isThisDateEqualToOrAfterThatDate(thisDate: Date | string, thatDate: Date | string) {
        const date1 = new Date(thisDate).getTime();
        const date2 = new Date(thatDate).getTime();
        if (!(date1 < date2)) {
            return true;
        } else {
            return false;
        }
    }

    // getDate(batch: ReportBatch) {
    //   return  moment(batch.AddedOn, ['MM/DD/YYYY']);
    // }

    itemExistsInArray(textFieldToFind: string, batchesToCheck: ReportBatch[]): boolean {
        let itemExists = false;

        for (let x = 0; x < batchesToCheck.length; x++) {
            if (batchesToCheck.find(p => p.ProcessingDescription == textFieldToFind)) {
                itemExists = true;
                break;
            }
        }

        return itemExists;

    }

    cancelClick(batch: ReportBatch) {
        // confirm they want to cancel the report to archive
        this.confirmCancelArchiveDialogRef = this.confirmCancelArchiveDialog.open(ConfirmCancelArchiveReportComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true
        });

        this.confirmCancelArchiveDialogRef.afterClosed().subscribe(result => {

            if (result == true) {
                this.cancelBatch(batch);
                // this.thisDialogRef.close();
            }
        });

        // batch.InProcess = false;

        // // mark as cancelling
        // this.reportService.cancellingReportBatch(batch).subscribe(batches => {
        //     this.ReportBatches = batches;
        // });

        // // now kick off background cancel
        // const asyncSub = this.reportService.startCancelReportBatchCleanupProcess(batch).subscribe(() => { });
        // setTimeout(() => {
        //     asyncSub.unsubscribe();
        // }, 0);

        // this.reportService.getReportBatches().subscribe(archiveBatches => {
        //     if (this.reportService.inDebugMode) {
        //         console.log(archiveBatches);
        //     }
        //     this.ReportBatches = archiveBatches;
        // });
    }


    cancelBatch(batch: ReportBatch) {
        batch.InProcess = false;

        // mark as cancelling
        this.reportService.cancellingReportBatch(batch).subscribe(batches => {
            this.ReportBatches = batches;

            batch.RemoveArchivedFiles = this.reportService.removeArchivedFiles;
            this.reportService.removeArchivedFiles = false; // reset to default behavior

            // // now kick off background cancel
            // const asyncSub = this.reportService.startCancelReportBatchCleanupProcess(batch).subscribe(() => { });
            // setTimeout(() => {
            //     // asyncSub.unsubscribe();
            //     this.reportService.getReportBatches().subscribe(archiveBatches => {

            //         for (let x = 0; x < archiveBatches.length; x++) {
            //             this.setAddedOnDate_Display(archiveBatches[x]);
            //         }
            //         if (this.reportService.inDebugMode) {
            //             console.log(archiveBatches);
            //         }
            //         this.ReportBatches = archiveBatches;

            //     }); // END getReportBatches
            // }, 0);


            this.reportService.startCancelReportBatchCleanupProcess(batch).subscribe(results => {
                // asyncSub.unsubscribe();
                this.reportService.getReportBatches().subscribe(archiveBatches => {

                    for (let x = 0; x < archiveBatches.length; x++) {
                        this.setAddedOnDate_Display(archiveBatches[x]);
                    }
                    this.ReportBatches = archiveBatches;

                }); // END getReportBatches
            });



        }); // END cancellingReportBatch

        // // now kick off background cancel
        // const asyncSub = this.reportService.startCancelReportBatchCleanupProcess(batch).subscribe(() => { });
        // setTimeout(() => {
        //     asyncSub.unsubscribe();
        // }, 0);

        // this.reportService.getReportBatches().subscribe(archiveBatches => {
        //     if (this.reportService.inDebugMode) {
        //         console.log(archiveBatches);
        //     }
        //     this.ReportBatches = archiveBatches;
        // });
    }

    deleteClick(batch: ReportBatch) {
        // confirm they want to delete any reports which have already been archived
        this.confirmCancelArchiveDialogRef = this.confirmCancelArchiveDialog.open(ConfirmCancelArchiveReportComponent, {
            panelClass: 'tyl-mat-dialog',
            disableClose: true,
            data: {
                header: 'Delete archived reports?',
                messageLine1: 'Are you sure you want to delete any archived reports in this batch?',
                messageLine2: 'If you continue, the reports will be deleted and this archive batch will be cancelled'
            }
        });

        this.confirmCancelArchiveDialogRef.afterClosed().subscribe(result => {

            if (result == true) {
                this.cancelBatch(batch);
                // this.thisDialogRef.close();
            }
        });

        // this.cancelBatch(batch);
    }

    getAddedOn(batch: ReportBatch) {
        return batch.AddedOn.toString().replace('T', ',');
    }

    getStatusFontColor(batch: ReportBatch) {
        if (batch.InProcess) {
            return 'green';
        } else {
            if (batch.HasError || batch.ProcessingDescription == 'Errored') {
                return 'red';
            } else {
                return 'default';
            }
        }
    }



    ngOnDestroy() {
    }

    refreshClick() {

        this.reportService.getReportBatches().subscribe(archiveBatches => {
            for (let x = 0; x < archiveBatches.length; x++) {
                this.setAddedOnDate_Display(archiveBatches[x]);
            }
            this.ReportBatches = archiveBatches;
            this.filteredBatches = this.getFilteredItems();
        });
    }

    closeClick() {

        this.dialogRef.close(true);
    }


}